import thomas from '$lib/assets/directors/admin_team/Dr. Thomas Mar Ivanios - Metropolitan & President.webp';
import jacob from '$lib/assets/directors/admin_team/Rev. Fr. Dr. Jacob Mathew - Diocesan Sunday School Director.webp';
import philip from '$lib/assets/directors/admin_team/Rev. Fr. Philip Abraham - Vice Director West Region.webp';
import john from '$lib/assets/directors/admin_team/Rev Fr. John Mathew - Vice Director South(Houston).webp';
import binny from '$lib/assets/directors/admin_team/Rev Fr. Binny Kuruvilla - Vice Director Northwest Region.webp';
import abey from '$lib/assets/directors/admin_team/Rev Fr. Abey Abraham - Vice Director Southeast Region.webp';
import joel from '$lib/assets/directors/admin_team/Rev. Fr. Joel Mathew - Vice Director South, Dallas.webp';
import shawn from '$lib/assets/directors/admin_team/Rev. Fr. Shawn Thomas - Vice Director Midwest (Detroit).webp';
import george from '$lib/assets/directors/ovbs_team/Rev. Fr. George Ninan - Director OVBS.webp';
import jithin from '$lib/assets/directors/admin_team/Rev. Fr. Jithin J Zachariah - Vice Director Midwest (Chicago).webp';
import diane from '$lib/assets/directors/admin_team/Diane Mathew - Secretary.webp';
import stephen from '$lib/assets/directors/admin_team/Stephen James - Treasurer.webp';
import linju from '$lib/assets/directors/ovbs_team/Linju Abraham - Diocesan OVBS Secretary.webp';
import ashley from '$lib/assets/directors/admin_team/Ashley Varghese - CWE Coordinator.webp';
import mathew from '$lib/assets/directors/admin_team/Mathew Koshy - Regional Coordinator Southeast.webp';
import promilla from '$lib/assets/directors/admin_team/Promilla Eapen - Regional Coordinator South(Houston).webp';
import jiji from '$lib/assets/directors/admin_team/Jiji Abraham - Regional Coordinator South (Dallas).webp';
import renju from '$lib/assets/directors/admin_team/Renju John - Regional Coordinator West Region.webp';
import della from '$lib/assets/directors/admin_team/Della Gejo - Regional Coordinator Northwest Region.webp';
import johnC from '$lib/assets/directors/admin_team/John Chacko - Regional Coordinator Midwest (Detroit).webp';
import sheeba from '$lib/assets/directors/admin_team/Sheeba Mathew - Regional Coordinator Midwest (Chicago).webp';
import gladstone from '$lib/assets/directors/ttc_team/GladstoneMammen.webp';
import directorImg from '$lib/assets/director.png';

export const director = [
	{
		name: 'Fr. Dr. Jacob Mathew',
		designation: 'Sunday School Director',
		image: directorImg,
		message:
			'John the Baptist is the patron saint of Sunday School. John the Baptist was born to Zacharia and Elizabeth in answer to their prayers and a promise from God. He grows up to be a prophet, preaching of the coming of the messiah. John the Baptist fulfills Biblical prophecy by recognizing Jesus as the promised Savior and baptizing Him going before the Lord. He is the patron saint of Sunday School because his life is an example for all Christians to follow.'
	}
];

export const directors = [
	{
		name: 'H.G. Dr. Thomas Mar Ivanios',
		title: 'Metropolitan & President',
		image: thomas
	},
	{
		name: 'Fr. Dr. Jacob Mathew',
		title: 'Sunday School Director',
		image: jacob
	},
	{
		name: 'Fr. Philip Abraham',
		title: 'Vice Director West ',
		image: philip
	},
	{
		name: 'Fr. John Mathew',
		title: 'Vice Director South(Houston)',
		image: john
	},
	{
		name: 'Fr. Binny Kuruvilla',
		title: 'Vice Director Northwest ',
		image: binny
	},
	{
		name: 'Fr. Abey Abraham',
		title: 'Vice Director Southeast ',
		image: abey
	},

	{
		name: 'Fr. Joel Mathew',
		title: 'Vice Director South, Dallas',
		image: joel
	},

	{
		name: 'Fr. Shawn Thomas',
		title: 'Vice Director Midwest (Detroit)',
		image: shawn
	},
	{
		name: 'Fr. George Ninan',
		title: 'OVBS Director',
		image: george
	},
	{
		name: 'Fr. Jithin J Zachariah',
		title: 'Vice Director Midwest (Chicago)',
		image: jithin
	},
	{
		name: 'Diane Mathew',
		title: 'Sunday School General Secretary',
		image: diane
	},
	{
		name: 'Stephen James',
		title: 'Sunday School Treasurer',
		image: stephen
	},
	{
		name: 'Linju Abraham (Kochamma)',
		title: 'Diocesan OVBS Secretary',
		image: linju
	},
	{
		name: 'Ashley Varghese (Kochamma)',
		title: 'CWE Coordinator',
		image: ashley
	},
	{
		name: 'Mathew Koshy',
		title: 'Regional Coordinator Southeast',
		image: mathew
	},
	{
		name: 'Promilla Eapen',
		title: 'Regional Coordinator South(Houston)',
		image: promilla
	},
	{
		name: 'Jiji Abraham',
		title: 'Regional Coordinator South (Dallas)',
		image: jiji
	},
	{
		name: 'Renju John',
		title: 'Regional Coordinator West Region',
		image: renju
	},
	{
		name: 'Della Gejo',
		title: 'Regional Coordinator Northwest Region',
		image: della
	},
	{
		name: 'John Chacko',
		title: 'Regional Coordinator Midwest (Detroit)',
		image: johnC
	},
	{
		name: 'Sheeba Mathew',
		title: 'Regional Coordinator Midwest (Chicago)',
		image: sheeba
	},
	{
		name: 'Gladstone Mammen',
		title: 'TTC & Diploma Team Lead',
		image: gladstone
	}
];
